module.exports = __webpack_public_path__ + "static/img/ausencia.648220e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buttons/ausencia.png
// module id = 231
// module chunks = 1